import * as z from "zod/v4";

export const deleteAeoPromptTag = {
  name: "deleteAeoPromptTag" as const,
  input: z.object({ tagId: z.bigint() }),
  output: z.object({ deleted: z.boolean() }),
};
